import {format} from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

export class ExtendedDateFnsUtilsUtils extends AdapterDateFns {
    getCalendarHeaderText(date: Date): string {
        return format(date, 'yyyy年 MMM', {locale: this.locale});
    }

    getDatePickerHeaderText(date: Date): string {
        return format(date, 'MMMd日', {locale: this.locale});
    }
}
